import React, { useState, useEffect } from "react";
import Header from '../components/Header'
import Footer from '../components/Footer'
import { Link } from 'react-router-dom'
import usePageSEO from '../hooks/usePageSEO'
import axios from "axios";
import Loader from '../components/Loader'

const Careers = () =>{
  const [loading, setLoading] = useState(true);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const siteUrl = process.env.REACT_APP_BACKEND_URL;

  const [data, setData] = useState('');
  const [metaTitle, setMetaTitle] = useState('');
  const [metaDescription, setMetaDescription] = useState('');

  const [widgetData1, setWidgetData1] = useState('');
  const [widgetData2, setWidgetData2] = useState('');
  const [widgetData3, setWidgetData3] = useState('');
  const [widgetData4, setWidgetData4] = useState('');
  const [widgetData5, setWidgetData5] = useState('');
  const [company, setCompany] = useState('');
  const apiUrl = apiBaseUrl+`careerpage`;


  const fetchInfo = () => {
    return axios.get(apiUrl).then((res) => {
      setData(res.data.page)
      setMetaTitle(res.data.page.meta_title);
      setMetaDescription(res.data.page.meta_description);
      setWidgetData1(res.data.career1widget);
      setWidgetData2(res.data.career2widget);
      setWidgetData3(res.data.career3widget);
      setWidgetData4(res.data.career4widget);
      setWidgetData5(res.data.career5widget);
      setCompany(res.data.company);
    });
  };

  useEffect(() => {
    setTimeout(() => {
      fetchInfo()
        setLoading(false);
    }, 2000);
  }, []);

  usePageSEO({
    title: `${metaTitle}`,
    description: `${metaDescription}`
  })     


  return (
    <>
    <Header/>
	{ loading && (<Loader /> )}
    <section className="section-content-block">
        <div className="container">
            <div className="row">
                <div className="col-md-offset-2 col-md-8 col-sm-12 text-center">                       
                    <div className="about-us-intro">
                        <p className="blue">{data?.name}</p>
                        <h2 className="heading">{data?.page_heading}</h2>
                        <p>{data?.short_description}</p>
                    </div>                            
                </div> 
            </div>
        </div>
    </section>
    
    <div className="container"><hr /></div>
    
    <section className="section-content-block">
        <div className="container wow fadeIn animated" style={{ visibility: "visible", animationName: "fadeIn" }}>
            <div className="row development">
                <div className="col-md-offset-2 col-md-8 col-sm-12 text-center">    
                    <p className="blue">{widgetData1?.name}</p>
                    <p className="our-experience">{widgetData1?.heading}</p>
                    <div className="about-us-intro">
                        <p>{widgetData1?.description}</p>
                    </div>                            
                </div> 
            </div>
        </div>         
    </section>

    <div className="container"><hr /></div>

    <section className="section-content-block">
        <div className="container custom-development">

            <div className="row development">
                <div className="col-lg-6 col-md-6 col-sm-12">                       
                    <div className="about-us-intro employee">
                        <h2 className="heading">{widgetData2?.heading}</h2>
                        <p>{widgetData2?.description}</p>	
                    </div>                            
                </div> 
                <div className="col-lg-6 col-md-6 col-sm-12 text-right">
                    <img src={`${siteUrl}${widgetData2?.image}`} alt={widgetData2?.name} />               
                </div>
            </div>
            
            <div className="row development visible-lg visible-md visible-sm hidden-xs">
                <div className="col-lg-6 col-md-6 col-sm-12 text-right">
                    <img src={`${siteUrl}${widgetData3?.image}`} alt={widgetData3?.name} />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">                       
                    <div className="about-us-intro employee">
                        <h2 className="heading">{widgetData3?.heading}</h2>
                        <p>{widgetData3?.description}</p>
                    </div>                            
                </div>
            </div>

            <div className="row development visible-xs hidden-lg hiden-md hidden-sm">
                <div className="col-lg-6 col-md-6 col-sm-12">                       
                    <div className="about-us-intro employee">
                        <h2 className="heading">{widgetData3?.heading}</h2>
                        <p>{widgetData3?.description}</p>
                    </div>                            
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 text-right">
                    <img src={`${siteUrl}${widgetData3?.image}`} alt={widgetData3?.name} />               
                </div>
            </div>                
            
            <div className="row development">
                <div className="col-lg-6 col-md-6 col-sm-12">                       
                    <div className="about-us-intro employee">
                        <h2 className="heading">{widgetData4?.heading}</h2>
                        <p>{widgetData4?.description}</p>
                    </div>                            
                </div> 
                <div className="col-lg-6 col-md-6 col-sm-12 text-right">
                    <img src={`${siteUrl}${widgetData4?.image}`} alt={widgetData4?.name} />               
                </div>
            </div>
        </div> 
    </section>

    <div className="container"><hr /></div>
    
    <section className="section-content-block">
        <div className="container custom-development">
            <div className="row development">
                <div className="col-lg-6 col-md-6 col-sm-12">                       
                    <div className="about-us-intro padding-top-100 employee1">
                        <p className="blue">{widgetData5?.name}</p>
                        <h2 className="heading">{widgetData5?.heading}</h2>
                        <p>{widgetData5?.description}</p>
                        <p className="custom-email"><Link to={`mailto:${company?.hr_email}`}>{company?.hr_email}</Link></p>
                        <p className='form-group'><Link to={company?.job_opening_link} className="custom-social-icom1"><i className="fa fa-linkedin-square"></i>Check Junna Solar's LinkedIn page for latest job openings</Link></p>
                    </div>                            
                </div> 
                <div className="col-lg-6 col-md-6 col-sm-12 text-right">
                    <div className="row">
                        <div className='col-sm-12 col-lg-12 col-md-12 form-group'>
                            <img src={`${siteUrl}${widgetData5?.image}`} alt={widgetData5?.name} />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-sm-6 col-lg-6 col-md-6 form-group'>
                            <img src={`${siteUrl}${widgetData5?.image2}`} alt={widgetData5?.name} />
                        </div>
                        <div className='col-sm-6 col-lg-6 col-md-6 form-group'>
                            <img src={`${siteUrl}${widgetData5?.image3}`} alt={widgetData5?.name} />
                        </div>                                                         
                    </div>
                </div>
            </div>
        </div> 
    </section>

    <Footer/>    
    </>
  )
}

export default Careers